import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Card, Icon, Pressable } from '@ui/themed';

export function PartnerActionCard(props: {
  icon?: IconName;
  title: string;
  body: string;
  action: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-1 items-stretch justify-center', props.className)}>
      <Pressable fullWidth={true} fullHeight={true} type="card" onClick={props.onClick}>
        <Card size="md">
          <Card.Header headingLevel="h2" icon={props.icon}>
            {props.title}
          </Card.Header>
          <Card.Body>
            <div className="flex flex-col gap-3 text-start">
              {props.body}
              <span className="inline-flex items-center gap-1 font-medium">
                {props.action}
                <Icon name="arrowRight" />
              </span>
            </div>
          </Card.Body>
        </Card>
      </Pressable>
    </div>
  );
}
